import { html } from "lit";
import { ifDefined } from "lit/directives/if-defined.js";

interface TemplateArgs {
    className?: string;
    imageUrl?: string;
    imageAlt?: string;
    headingLevel?: number;
    headline?: string;
    subheadline?: string;
    description?: string;
    contactHeadline?: string;
    contactPhoneLabel?: string;
    contactPhoneNumber?: string;
    contactEmailLabel?: string;
    contactEmailAddress?: string;
    contactServiceLabel?: string;
    contactServiceLink?: string;
    contactServiceTarget?: string;
}

export const Template = ({
    className,
    imageUrl,
    imageAlt,
    headingLevel,
    headline,
    subheadline,
    description,
    contactHeadline,
    contactPhoneLabel,
    contactPhoneNumber,
    contactEmailLabel,
    contactEmailAddress,
    contactServiceLabel,
    contactServiceLink,
    contactServiceTarget,
}: TemplateArgs) => html`
    <ux-iws-nb-teaser-contact
        class=${ifDefined(className)}
        image-url=${ifDefined(imageUrl)}
        image-alt=${ifDefined(imageAlt)}
        heading-level=${ifDefined(headingLevel)}
        headline=${ifDefined(headline)}
        subheadline=${ifDefined(subheadline)}
        description=${ifDefined(description)}
        contact-headline=${ifDefined(contactHeadline)}
        contact-phone-label=${ifDefined(contactPhoneLabel)}
        contact-phone-number=${ifDefined(contactPhoneNumber)}
        contact-email-label=${ifDefined(contactEmailLabel)}
        contact-email-address=${ifDefined(contactEmailAddress)}
        contact-service-label=${ifDefined(contactServiceLabel)}
        contact-service-link=${ifDefined(contactServiceLink)}
        contact-service-target=${ifDefined(contactServiceTarget)}
    ></ux-iws-nb-teaser-contact>
`;

export const templateArgs = {
    imageUrl: "./mock-assets/images/nimbus-contact-teaser.jpg",
    imageAlt: "Contact Image with 16:9 aspect ratio",
    headingLevel: 3,
    headline: "Noch nicht das richtige Produkt gefunden?",
    subheadline: "Wir helfen gerne!",
    description:
        "Lassen Sie sich von unseren Experten beraten, um die perfekte Lösung für ihre Anwendung zu finden.",
    contactHeadline: "Kontakt",
    contactPhoneLabel: "Telefon",
    contactPhoneNumber: "+49 7156 30330862",
    contactEmailLabel: "E-Mail",
    contactEmailAddress: "service@trumpf.com",
    contactServiceLabel: "Zur Aussendienstsuche",
    contactServiceLink: "https://www.trumpf.com",
    contactServiceTarget: "_blank",
};
